


































































import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";

import { formatMMddyyyyDateString } from "@/shared/dateString";
import { AuthorizedSigner } from "@/shared/types";

@Component({
  components: { }
})
export default class AuthorizedSignerTable extends Vue {
  formatDateString = formatMMddyyyyDateString;

  @Prop ()
  authorizedSigners: AuthorizedSigner[];

  @Prop ({required: false, default: true})
  isActive: boolean;

  collapseId (id: number): string {
    return `collapse-${id}`;
  }

  toggleDetails (collapseId: string) {
    this.$root.$emit("bv::toggle::collapse", collapseId);
    this.toggleCollapsedClass(collapseId);
  }

  toggleCollapsedClass (collapseId: string) {
    const elem = document.getElementById(collapseId);
    if (elem.classList.contains("collapsed")) {
      elem.classList.remove("collapsed");
    } else {
      elem.classList.add("collapsed");
    }
  }

  middleInitial (authorizedSigner: AuthorizedSigner): string {
    if (authorizedSigner.middleInitial) {
      return authorizedSigner.middleInitial;
    }
    return "";
  }

  fullName (authorizedSigner: AuthorizedSigner): string {
    return `${authorizedSigner.firstName} ${this.middleInitial(authorizedSigner)} ${authorizedSigner.lastName}`;
  }

  dateOfBirth (authorizedSigner: AuthorizedSigner): string {
    return this.formatDateString(authorizedSigner.dateOfBirth);
  }

  lastFourSsn (authorizedSigner: AuthorizedSigner): string {
    if (!authorizedSigner || !authorizedSigner.ssn) {
      return "";
    }

    const ssnTrimmed = authorizedSigner.ssn.trim();
    const ssnLength = ssnTrimmed ? ssnTrimmed.length : 0;
    if (ssnLength === 9) {
      return `***-**-${ssnTrimmed.substring(5, ssnLength)}`;
    }

    return `***-**-${ssnTrimmed.substring(7, ssnLength)}`;
  }

  phoneNumber (authorizedSigner: AuthorizedSigner): string {
    if (!authorizedSigner || !authorizedSigner.phone) {
      return "";
    }

    const phoneTrimmed = authorizedSigner.phone.trim();
    const phoneLength = phoneTrimmed ? phoneTrimmed.length : 0;
    if (phoneLength === 10) {
      const areaCode = phoneTrimmed.slice(0, 3);
      const second = phoneTrimmed.slice(3, 6);
      const third = phoneTrimmed.slice(6, 10);
      return `${areaCode}-${second}-${third}`;
    }
    return phoneTrimmed;
  }
}
